import { Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PublicFiltersProps {
  sportTypes: string[];
  selectedSportType: string;
  onSportTypeChange: (value: string) => void;
  selectedOwnership: string;
  onOwnershipChange: (value: string) => void;
  onReset: () => void;
}

const SPORT_TYPE_LABELS: Record<string, string> = {
  soccer_pitch: "Soccer",
  tennis_court: "Tennis",
  padel_court: "Padel",
  basketball_court: "Basketball",
  volleyball_court: "Volleyball",
  running_track: "Running",
  baseball_diamond: "Baseball",
  rugby_pitch: "Rugby",
  field_hockey_pitch: "Hockey",
  cricket_pitch: "Cricket",
  skateboard_park: "Skate",
  multi_sport_court: "Multi-Sport",
  beach_volleyball_court: "Beach V-ball",
  petanque_court: "Petanque",
  street_workout_area: "Workout",
  pickleball_court: "Pickleball",
  ping_pong_table: "Ping Pong",
  swimming_pool: "Swimming",
  athletics_track: "Athletics",
  outdoor_fitness: "Outdoor Fitness",
  playground: "Playground",
  climbing_wall: "Climbing",
  golf_course: "Golf",
  disc_golf_course: "Disc Golf",
  ice_skating_rink: "Ice Skating",
  handball_court: "Handball",
};

export function PublicFilters({
  sportTypes,
  selectedSportType,
  onSportTypeChange,
  selectedOwnership,
  onOwnershipChange,
  onReset,
}: PublicFiltersProps) {
  const hasFilters = selectedSportType !== "all" || selectedOwnership !== "all";

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b">
      <Filter className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <Select value={selectedSportType} onValueChange={onSportTypeChange}>
        <SelectTrigger className="h-7 text-xs w-[140px]">
          <SelectValue placeholder="Sport type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All sports</SelectItem>
          {sportTypes.map((type) => (
            <SelectItem key={type} value={type}>
              {SPORT_TYPE_LABELS[type] ?? type.replace(/_/g, " ")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={selectedOwnership} onValueChange={onOwnershipChange}>
        <SelectTrigger className="h-7 text-xs w-[130px]">
          <SelectValue placeholder="Ownership" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All ownership</SelectItem>
          <SelectItem value="public">Public</SelectItem>
          <SelectItem value="private">Private</SelectItem>
          <SelectItem value="institutional">Institutional</SelectItem>
          <SelectItem value="unknown">Unknown</SelectItem>
        </SelectContent>
      </Select>
      {hasFilters && (
        <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={onReset}>
          Clear
        </Button>
      )}
    </div>
  );
}
